import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "template"];

  add(event) {
    event.preventDefault();

    const index = new Date().getTime();
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, index);
    const wrapper = document.createElement("template");
    wrapper.innerHTML = html.trim();
    const item = wrapper.content.firstElementChild;

    // Set position dynamically from the currently-visible item count,
    // rather than trusting whatever static value got baked into the
    // <template> at page-render time - that value doesn't change as
    // more rows get added client-side in the same session, so two
    // "add" clicks would otherwise produce two rows with the same
    // position (harmless for display order, but this value doubles as
    // a join key for the seat/baggage matrix on the new-flight form -
    // see flight_matrix_controller.js - where duplicates would collide).
    const positionField = item.querySelector('input[name*="[position]"]');
    if (positionField) {
      const visibleCount = this.containerTarget.querySelectorAll(
        '[data-nested-fields-target="item"]:not([hidden])'
      ).length;
      positionField.value = visibleCount;
    }

    this.containerTarget.appendChild(item);
    this.dispatch("changed", { detail: { action: "add", item } });
  }

  remove(event) {
    event.preventDefault();

    const item = event.target.closest('[data-nested-fields-target="item"]');
    const destroyField = item.querySelector('input[name*="[_destroy]"]');
    const idField = item.querySelector('input[name*="[id]"]');

    if (destroyField && idField && idField.value) {
      destroyField.value = "1";
      item.hidden = true;
    } else {
      item.remove();
    }

    this.dispatch("changed", { detail: { action: "remove", item } });
  }
}
